var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 10.6072C19.7143 14.8677 16.2606 18.3214 12.0001 18.3214M12.0001 18.3214C7.73957 18.3214 4.28577 14.8677 4.28577 10.6072M12.0001 18.3214V21.2143M12.0001 21.2143H14.8929M12.0001 21.2143H9.1072M16.8215 6.75002V10.6072C16.8215 13.2699 14.6628 15.4286 12.0001 15.4286C9.33725 15.4286 7.17862 13.2699 7.17862 10.6072V6.75002C7.17862 4.08722 9.33725 1.92859 12.0001 1.92859C14.6628 1.92859 16.8215 4.08722 16.8215 6.75002Z",
    stroke: "#6B87E6",
    strokeWidth: 1.44643,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.108767b67117acf6eb105466789a28fb.svg";
export { ForwardRef as ReactComponent };